import HairProfile from './HairProfile'
import ProductSlider from './ProductSlider'
import { formatReturningProfileData } from './utils/profileSummaryHelpers'

const ChatMessage = ({
  message,
  agentData,
  aiLogo,
  selectedProduct,
  onProductSelect,
  onOpenDiagnostics,
  goToPricing,
  loadingText,
  translations,
  language,
}) => {
  return (
    <div className={`msg-row ${message.from}`}>
      <img
        src={message.from === 'user' ? agentData?.agentProfilePicture : aiLogo}
        alt={message.from}
        className='msg-avatar'
      />

      <div className='msg-col'>
        {message.productsLoading && (
          <div className='products-loading'>
            <div className='products-loading-spinner' />
            <div className='products-loading-text'>{loadingText}</div>
          </div>
        )}

        {!message.productsLoading && (message.text || message.photoUrl) && (
          <div className={`bubble ${message.from}`}>
            {message.text && <span>{message.text}</span>}

            {message.photoUrl && (
              <img
                src={message.photoUrl}
                alt='Hair'
                className='photo-preview'
              />
            )}
          </div>
        )}

        {message.showUserProfile && (
          <HairProfile
            userName={agentData?.agentFullName || 'User'}
            userAvatar={agentData?.agentProfilePicture}
            hairType={
              agentData?.hair_type ||
              agentData?.hair_class ||
              agentData?.hairClass ||
              'Unknown'
            }
            profileItems={formatReturningProfileData(
              agentData,
              translations,
              language,
            )}
            hairPhoto={
              agentData?.hair_mask
                ? `data:image/png;base64,${agentData.hair_mask}`
                : agentData?.hair_photo || null
            }
          />
        )}

        {message.hairProfile && <HairProfile {...message.hairProfile} />}

        {message.showSlider && (
          <ProductSlider
            title={message.sliderTitle}
            selectedProduct={selectedProduct}
            onAdd={onProductSelect}
            onOpenDiag={onOpenDiagnostics}
            goToPricing={goToPricing}
          />
        )}

        {!message.productsLoading && (
          <span className='msg-time'>{message.time}</span>
        )}
      </div>
    </div>
  )
}

export default ChatMessage
